// @flow
import moment from 'moment';

export const getDisabledEqipmentInstallRemoveDate = (currentDate: moment) => {
  return moment(currentDate).isAfter(moment().endOf('day'));
};
